/* SwitchToOsPlanRenderer.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");

class SwitchToOsPlanRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("os-plan-view-gl");
        this._logger = this._model.logger;
    }

    shutdown() {
        this._model = undefined;
        this._rootElem = undefined;
        this._logger = undefined;
        return Promise.resolve();
    }

    get rootElement() {
        return this._rootElem;
    }

    get model() {
        return this._model;
    }

    render() {
        if (this.model._solutionsManager.getActiveSolution().name === "os_manager") {
            //this.model.closeAllEditors();
            this.model._gameEditor._cabinetCmpnt.emit("ExplorerChanged");
            this.model._gameEditor.openLMRBExplorer(Registrations.OS_PLAN_EXPLORER_LMRB);
        }
    }
}

module.exports = SwitchToOsPlanRenderer;
